// LapstrLogo.jsx
export default function LapstrLogo({
    text = "Lapstr",
    className = "",
    outline = 10,        // i viewBox-enheter (skalar snyggt med SVG:n)
}) {
    return (
        <svg
            className={`block w-full h-auto ${className}`}
            viewBox="0 0 1200 260"
            role="img"
            aria-label={text}
            preserveAspectRatio="xMidYMid meet"
        >
            <defs>
                <filter id="outerStroke" x="-20%" y="-40%" width="140%" height="200%">
                    <feMorphology in="SourceAlpha" operator="dilate" radius={outline} result="dilated" />
                    <feFlood floodColor="#000" />
                    <feComposite in2="dilated" operator="in" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feMerge><feMergeNode /></feMerge>
                </filter>
            </defs>

            {/* YTTRE OUTLINE */}
            <text
                x="50%" y="68%"
                textAnchor="middle"
                fontFamily="'Source Sans 3', system-ui, sans-serif"
                fontSize="200"
                fontWeight="900"
                fontStyle="italic"
                filter="url(#outerStroke)"
            >
                {text}
            </text>

            {/* FYLLNING */}
            <text
                x="50%" y="68%"
                textAnchor="middle"
                fontFamily="'Source Sans 3', system-ui, sans-serif"
                fontSize="200"
                fontWeight="900"
                fontStyle="italic"
                fill="#fff"
            >
                {text}
            </text>
        </svg>
    );
}
